export const BUYING_TYPE = 'buying_type'
export const BUDGET_MODE_TOTAL = 'BUDGET_MODE_TOTAL'
export const BUDGET_MODE_DAY = 'BUDGET_MODE_DAY'
